const STORAGE_KEY = 'formDrafts';
const OPEN_KEY = 'formDraftOpen';

const readAll = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
};

const writeAll = (all) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
};

/** Unsaved form builder work for one form. `new` is a form that has never been saved. */
export function readFormDraft(key) {
  if (!key) return null;
  const entry = readAll()[key];
  return entry?.schema || null;
}

export function readFormDraftSavedAt(key) {
  if (!key) return null;
  return readAll()[key]?.savedAt || null;
}

export function writeFormDraft(key, schema) {
  if (!key) return;
  const all = readAll();
  all[key] = { schema, savedAt: Date.now() };
  writeAll(all);
  localStorage.setItem(OPEN_KEY, key);
}

export function clearFormDraft(key) {
  if (!key) return;
  const all = readAll();
  delete all[key];
  writeAll(all);
  if (localStorage.getItem(OPEN_KEY) === key) localStorage.removeItem(OPEN_KEY);
}

export function listFormDrafts() {
  return readAll();
}

export function markFormDraftOpen(key) {
  if (key) localStorage.setItem(OPEN_KEY, key);
}

export function readFormDraftOpen() {
  return localStorage.getItem(OPEN_KEY);
}

/** Leave the builder without deleting the draft, so the list can offer to continue. */
export function closeFormDraft() {
  localStorage.removeItem(OPEN_KEY);
}
